export default __webpack_public_path__ + "static/media/healthscore-icon-bad.7ad31b00.svg";